import { ALLOWED_DURATIONS } from '@/screens/one-on-one/config';
import { DateTimeInterval } from '@/screens/one-on-one/types/types';
import Day from '@/screens/one-on-one/utils/day';
import { create } from 'zustand';

type ModalStatus = 'open' | 'busy' | 'error' | 'closed';

type StateType = {
  selectedItem: any;
  start: Day;
  end: Day;
  selectedDate?: Day;
  timeZone: string;
  duration: number;
  modal: ModalStatus;
  selectedTime?: DateTimeInterval;
  setSelectedDate: (date: Day) => void;
  setTimeZone: (zone: string) => void;
  setDuration: (minutes: number) => void;
  setModal: (status: ModalStatus) => void;
  setSelectedTime: (interval: DateTimeInterval) => void;
  setSelectedItem: any;
};

const useOneOnOneStore = create<StateType>(set => ({
  selectedItem: null,
  start: Day.todayWithOffset(0),
  end: Day.todayWithOffset(25),
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  duration: ALLOWED_DURATIONS[1],
  modal: 'closed',

  setSelectedDate: selectedDate => set(() => ({ selectedDate })),
  setTimeZone: timeZone => set(() => ({ timeZone })),
  setDuration: duration => set(() => ({ duration })),
  setModal: modal => set(() => ({ modal })),
  setSelectedTime: selectedTime =>
    set(state => ({
      selectedTime,
      modal: 'open',
    })),
  setSelectedItem: (selectedItem: any) => set(() => ({ selectedItem })),
}));

export default useOneOnOneStore;
